import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { IncrementalDeliveryProtocol_V0_1_getInstancedviv089p54f2 as IncrementalDeliveryProtocol_V0_1_getInstance } from '../IncrementalDeliveryProtocol.mjs';
import { Unit_instance3vdlo4e4f5ggx as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { WebSocketEngine1lh73ie4wh0m5 as WebSocketEngine } from './WebSocketEngine.js.mjs';
import {
  Companion_getInstance4z8fvmvpott5 as Companion_getInstance,
  toDuration7gy6v749ektt as toDuration,
  Duration5ynfiptaqcrg as Duration,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { DurationUnit_SECONDS_getInstancehu17fry790z2 as DurationUnit_SECONDS_getInstance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import { GraphQLWsProtocol3nqe2321ot0cb as GraphQLWsProtocol } from './GraphQLWsProtocol.mjs';
import { get_impl1focltg7f8wvg as get_impl } from '../../internal/incremental/IncrementalDeliveryProtocolImpl.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { uuid4al7pp0fcb8o5 as uuid4 } from '../../../../../../uuid/com/benasher44/uuid/uuid.mjs';
import { awaitClose2xaex743rz43v as awaitClose } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Produce.mjs';
import { WebSocketPool28m608awosr6h as WebSocketPool } from './internal/WebSocketPool.mjs';
import { callbackFlow1g384rkuy0hni as callbackFlow } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Builders.mjs';
import { buffer2o7vhreze5nfc as buffer } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Context.mjs';
import { Builder16nv925388a0q as Builder } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/ApolloResponse.mjs';
import { ChannelResult2y4k69ac6y3du as ChannelResult } from '../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/channels/Channel.mjs';
import {
  SubscriptionOperationException3t8cqqpx8bt9j as SubscriptionOperationException,
  DefaultApolloException8w3ielfxng0h as DefaultApolloException,
} from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/exception/Exceptions.mjs';
import { Key_getInstance1eahaybkym4fk as Key_getInstance } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/CustomScalarAdapters.mjs';
import { KtMap140uvy3s5zad8 as KtMap } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { jsonReader2agwreccj3lmk as jsonReader } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/json/JsonReaders.mjs';
import { toApolloResponse9u5mcqg84l2p as toApolloResponse } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Operations.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function WebSocketNetworkTransport$Builder$build$slambda() {
  return constructCallableReference(function *($completion) {
    return null;
  }, 0);
}
var BuilderClass;
function Builder_0() {
  if (BuilderClass === VOID) {
    class $ {
      constructor() {
        this.q61_1 = null;
        this.r61_1 = null;
        this.s61_1 = null;
        this.t61_1 = null;
        this.u61_1 = null;
        this.v61_1 = null;
        this.w61_1 = null;
        this.x61_1 = IncrementalDeliveryProtocol_V0_1_getInstance();
      }
      m61(serverUrl) {
        // Inline function 'kotlin.apply' call
        this.q61_1 = serverUrl;
        return this;
      }
      y61(idleTimeout) {
        // Inline function 'kotlin.apply' call
        this.v61_1 = idleTimeout;
        return this;
      }
      i37() {
        var tmp0_elvis_lhs = this.r61_1;
        var tmp5_webSocketEngine = tmp0_elvis_lhs == null ? WebSocketEngine() : tmp0_elvis_lhs;
        var tmp6_serverUrl = this.q61_1;
        var tmp1_elvis_lhs = this.v61_1;
        var tmp;
        var tmp_0 = tmp1_elvis_lhs;
        if ((tmp_0 == null ? null : new (Duration())(tmp_0)) == null) {
          // Inline function 'kotlin.time.Companion.seconds' call
          Companion_getInstance();
          tmp = toDuration(60, DurationUnit_SECONDS_getInstance());
        } else {
          tmp = tmp1_elvis_lhs;
        }
        var tmp7_idleTimeout = tmp;
        var tmp2_elvis_lhs = this.s61_1;
        var tmp_1;
        if (tmp2_elvis_lhs == null) {
          tmp_1 = new (GraphQLWsProtocol())(WebSocketNetworkTransport$Builder$build$slambda());
        } else {
          tmp_1 = tmp2_elvis_lhs;
        }
        var tmp8_wsProtocol = tmp_1;
        var tmp9_pingInterval = this.u61_1;
        var tmp3_elvis_lhs = this.t61_1;
        var tmp_2;
        var tmp_3 = tmp3_elvis_lhs;
        if ((tmp_3 == null ? null : new (Duration())(tmp_3)) == null) {
          // Inline function 'kotlin.time.Companion.seconds' call
          Companion_getInstance();
          tmp_2 = toDuration(10, DurationUnit_SECONDS_getInstance());
        } else {
          tmp_2 = tmp3_elvis_lhs;
        }
        var tmp10_connectionAcknowledgeTimeout = tmp_2;
        var tmp4_elvis_lhs = this.w61_1;
        var tmp11_parserFactory = tmp4_elvis_lhs == null ? new (DefaultSubscriptionParserFactory())(get_impl(this.x61_1)) : tmp4_elvis_lhs;
        return new (WebSocketNetworkTransport())(tmp5_webSocketEngine, tmp6_serverUrl, tmp8_wsProtocol, tmp10_connectionAcknowledgeTimeout, tmp9_pingInterval, tmp7_idleTimeout, tmp11_parserFactory);
      }
    }
    initMetadataForClass($, 'Builder', Builder_0);
    BuilderClass = $;
  }
  return BuilderClass;
}
function WebSocketNetworkTransport$execute$slambda($renewUuid, $request, this$0) {
  return constructCallableReference(function *($this$callbackFlow, $completion) {
    var tmp;
    if ($renewUuid._v) {
      tmp = $request.j41().c40(uuid4()).i37();
    } else {
      tmp = $request;
    }
    var newRequest = tmp;
    $renewUuid._v = true;
    var operationListener = new (DefaultOperationListener())(newRequest, $this$callbackFlow, this$0.c67_1.e67($request));
    var webSocket = this$0.d67_1.n67(newRequest);
    webSocket.b68(newRequest, operationListener);
    yield* awaitClose($this$callbackFlow, () => {
      webSocket.c68(newRequest);
      return Unit_instance;
    }, $completion);
    return Unit_instance;
  }, 1);
}
var WebSocketNetworkTransportClass;
function WebSocketNetworkTransport() {
  if (WebSocketNetworkTransportClass === VOID) {
    class $ {
      constructor(webSocketEngine, serverUrl, wsProtocol, connectionAcknowledgeTimeout, pingInterval, idleTimeout, parserFactory) {
        this.w66_1 = webSocketEngine;
        this.x66_1 = serverUrl;
        this.y66_1 = wsProtocol;
        this.z66_1 = connectionAcknowledgeTimeout;
        this.a67_1 = pingInterval;
        this.b67_1 = idleTimeout;
        this.c67_1 = parserFactory;
        this.d67_1 = new (WebSocketPool())(this.w66_1, this.x66_1, this.y66_1, this.z66_1, this.a67_1, this.b67_1);
      }
      t62(request) {
        var renewUuid = {_v: false};
        var flow = callbackFlow(WebSocketNetworkTransport$execute$slambda(renewUuid, request, this));
        return buffer(flow, 2147483647);
      }
      sz() {
        this.d67_1.l6();
      }
    }
    initMetadataForClass($, 'WebSocketNetworkTransport');
    WebSocketNetworkTransportClass = $;
  }
  return WebSocketNetworkTransportClass;
}
function errorResponse($this, cause) {
  return Builder().u41($this.d68_1.s40_1, $this.d68_1.t40_1).z41(cause).i37();
}
var DefaultOperationListenerClass;
function DefaultOperationListener() {
  if (DefaultOperationListenerClass === VOID) {
    class $ {
      constructor(request, producerScope, parser) {
        this.d68_1 = request;
        this.e68_1 = producerScope;
        this.f68_1 = parser;
      }
      g68(response) {
        var tmp0_safe_receiver = this.f68_1.h68(response);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var tmp$ret$0 = this.e68_1.c1b(tmp0_safe_receiver);
          new (ChannelResult())(tmp$ret$0);
        }
      }
      i68() {
        this.e68_1.n1b();
      }
      j68(payload) {
        this.e68_1.c1b(errorResponse(this, SubscriptionOperationException().o4e(this.d68_1.s40_1.operationName(), payload)));
        this.e68_1.n1b();
      }
      k68(cause) {
        this.e68_1.c1b(errorResponse(this, cause));
        this.e68_1.n1b();
      }
    }
    initMetadataForClass($, 'DefaultOperationListener');
    DefaultOperationListenerClass = $;
  }
  return DefaultOperationListenerClass;
}
var DefaultSubscriptionParserFactoryClass;
function DefaultSubscriptionParserFactory() {
  if (DefaultSubscriptionParserFactoryClass === VOID) {
    class $ {
      constructor(incrementalDeliveryProtocolImpl) {
        this.l68_1 = incrementalDeliveryProtocolImpl;
      }
      e67(request) {
        return new (DefaultSubscriptionParser())(this.l68_1, request);
      }
    }
    initMetadataForClass($, 'DefaultSubscriptionParserFactory');
    DefaultSubscriptionParserFactoryClass = $;
  }
  return DefaultSubscriptionParserFactoryClass;
}
var DefaultSubscriptionParserClass;
function DefaultSubscriptionParser() {
  if (DefaultSubscriptionParserClass === VOID) {
    class $ {
      constructor(incrementalDeliveryProtocolImpl, request) {
        this.m68_1 = request;
        this.n68_1 = incrementalDeliveryProtocolImpl.j64();
        var tmp = this;
        var tmp0_elvis_lhs = this.m68_1.w40_1.s45(Key_getInstance());
        tmp.o68_1 = tmp0_elvis_lhs == null ? Key_getInstance().f45_1 : tmp0_elvis_lhs;
      }
      h68(response) {
        var responseMap = (!(response == null) ? isInterface(response, KtMap()) : false) ? response : null;
        if (responseMap == null) {
          return Builder().u41(this.m68_1.s40_1, this.m68_1.t40_1).z41(DefaultApolloException().p42('Invalid payload')).i37();
        }
        var tmp;
        if (isDeferred(responseMap)) {
          tmp = to(this.n68_1.v64(responseMap), this.n68_1.r64());
        } else {
          tmp = to(responseMap, null);
        }
        var _destruct__k2r9zo = tmp;
        var payload = _destruct__k2r9zo.ze();
        var deferredFragmentIdentifiers = _destruct__k2r9zo.af();
        var apolloResponse = toApolloResponse(jsonReader(payload), this.m68_1.s40_1, this.m68_1.t40_1, this.o68_1, deferredFragmentIdentifiers);
        if (!this.n68_1.s64()) {
          this.n68_1.d3o();
        }
        var tmp_0;
        if (this.n68_1.t64()) {
          tmp_0 = null;
        } else {
          tmp_0 = apolloResponse;
        }
        return tmp_0;
      }
    }
    initMetadataForClass($, 'DefaultSubscriptionParser');
    DefaultSubscriptionParserClass = $;
  }
  return DefaultSubscriptionParserClass;
}
function isDeferred(_this__u8e3s4) {
  return _this__u8e3s4.v4().t2('hasNext');
}
//region block: exports
export {
  Builder_0 as Builder1suvx83rlbrz1,
};
//endregion

//# sourceMappingURL=WebSocketNetworkTransport.mjs.map
